import { boolPropsToClassNames } from 'common/utils/style.utils';
import {
  StyledInnerLineText,
  StyledLine,
  StyledLineText,
  StyledLineWrapper,
  StyledMultiLinesChart
} from './MultiLinesChart.style';
import { roundValue } from 'common/utils/utils';

const Line = ({ line }) => {
  const { loading, value, color, innerText, suffix = '%' } = line;
  if (!value && value !== 0) return null;

  const roundedValue = roundValue(value);
  const shouldShowInnerText = innerText && value > innerText?.length * 1.2;

  return (
    <StyledLineWrapper>
      <StyledLine
        value={value}
        color={color}
        className={boolPropsToClassNames({ loading })}
      >
        {shouldShowInnerText && (
          <StyledInnerLineText>{innerText}</StyledInnerLineText>
        )}
        {loading && !innerText && (
          <StyledInnerLineText>loading...</StyledInnerLineText>
        )}
      </StyledLine>
      {!loading && (
        <StyledLineText>
          {roundedValue}
          {suffix}
        </StyledLineText>
      )}
    </StyledLineWrapper>
  );
};

const MultiLinesChart = ({ lines }) => {
  return (
    <StyledMultiLinesChart>
      {lines.map((line, idx) => (
        <Line key={idx} line={line} />
      ))}
    </StyledMultiLinesChart>
  );
};

export default MultiLinesChart;
